import { useEffect } from 'react';
import './Pricing.css';

const Pricing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <title>Pricing - Pidesk</title>
      <meta name="description" content="Pricing for Pidesk's college ERP software, learning apps, websites and custom software development for institutes and businesses." />

      <div className="pricing-page">
        <div className="container">
          <div className="pricing-header">
            <h1>Simple Pricing</h1>
            <p>Choose the perfect plan for your digital needs</p>
          </div>

          <div className="pricing-cards">
            <div className="pricing-card featured">
              <div className="card-header">
                <h3>Test Plan</h3>
                <div className="price">
                  <span className="currency">₹</span>
                  <span className="amount">1</span>
                  <span className="period">/one-time</span>
                </div>
                <p className="description">Perfect for testing payment gateway</p>
              </div>
              
              <ul className="features">
                <li className="included">
                  <span className="check">✓</span>
                  Payment gateway testing
                </li>
                <li className="included">
                  <span className="check">✓</span>
                  KYC verification support
                </li>
                <li className="included">
                  <span className="check">✓</span>
                  Instant activation
                </li>
                <li className="included">
                  <span className="check">✓</span>
                  24/7 support
                </li>
              </ul>

              <a href="/contact" className="buy-link">
                <button className="btn btn-primary buy-btn">
                  Buy Now - ₹1
                </button>
              </a>
            </div>
          </div>

          <div className="pricing-info">
            <h3>Why Test with ₹1?</h3>
            <p>
              This minimal test amount helps verify your payment gateway integration and KYC status 
              without significant financial commitment. Once successful, you can proceed with larger transactions.
            </p>
            
            <div className="info-box">
              <h4>Payment Gateway Testing</h4>
              <ul>
                <li>✅ Verify merchant account status</li>
                <li>✅ Test KYC compliance</li>
                <li>✅ Validate payment flow</li>
                <li>✅ Check webhook integration</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pricing;
